import Machine360Analytics from "./Machine360Analytics";

export default Machine360Analytics;
export { Machine360Analytics };
